export default __webpack_public_path__ + "static/SammonsIndustrial_vert-white-85dbda3f749c038d6956fd98875ab828.png";